<script setup>
const props = defineProps({
    initialFormId: {
        type: Number,
        required: true,
    },
    formTitle: {
        type: String,
        required: true,
    },
});
</script>

<template>
    <div>
        <div class="md:sticky top-2 z-topbar">
            <frosted-bar>
                <div class="flex items-center justify-between space-x-4">
                    <h1>{{ formTitle }}</h1>
                </div>

                <template #navigation>
                    <a :href="route('forms.charts')" class="mf-link text-xs">{{ _mft('form:chart.pageTitle') }}</a>
                </template>
            </frosted-bar>
        </div>

        <form-charts-for-form-content :initial-form-id="initialFormId" />
    </div>
</template>
